import type { OrderProductStatusId } from '@witmetrics/utils';
import { ORDER_PRODUCT_STATUSES } from '@witmetrics/utils/constants';

export const LABELS = Object.values(ORDER_PRODUCT_STATUSES).reduce(
  (a, b) => ({ ...a, [b.id]: b.label }),
  {} as Record<OrderProductStatusId, string>
);
